module.exports = __webpack_public_path__ + "static/media/proven-engagement.447ce22d.svg";